module.exports = __webpack_public_path__ + "img/glasses.ad00d906.svg";